import ArrowPairSquarepathIconPath from "@ingka/ssr-icon/paths/arrow-pair-squarepath";

export default ArrowPairSquarepathIconPath;
